import { render, staticRenderFns } from "./EnvioAutomatico.vue?vue&type=template&id=4de099aa"
import script from "./EnvioAutomatico.vue?vue&type=script&lang=js"
export * from "./EnvioAutomatico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports